'use strict';
angular.module("editNoticeTypeModule", [])
    .controller("editNoticeTypeCtrl", ["$scope", "$modalInstance", "$q", "trsHttpService", "modalDialog", "noticeType", "$validation", "$rootScope",
        function($scope, $modalInstance, $q, trsHttpService, modalDialog, noticeType, $validation, $rootScope) {
            initStatus();
            initData();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    isEdit: angular.isDefined(noticeType) ? true : false
                }
                $scope.data = {

                }
            }
            /**
             * [initData description] 状态初始化
             * @return {[type]} [description]
             */
            function initData() {
                if (angular.isDefined(noticeType)) {
                    $scope.data.noticeType = noticeType;
                } else {
                    $scope.data.noticeType = {
                        status: 0,
                        typename: ''
                    }
                }
            }
            /**
             * [stopOrStart description] 启用/停用
             * @return {[type]} [description]
             */
            $scope.stopOrStart = function() {
                    $scope.data.noticeType.status = $scope.data.noticeType.status == 0 ? 1 : 0;
                }
                /**
                 * [cancel description] 取消
                 * @return {[type]} [description]
                 */
            $scope.cancel = function() {
                    $modalInstance.dismiss();
                }
                /**
                 * [confirm description] 确定
                 * @return {[type]} [description]
                 */
            $scope.confirm = function() {
                let defer = $q.defer();
                $scope.noticetypeForm.$pending = {};
                $validation.validate($scope.noticetypeForm)
                    .success(function() {
                        let params = $scope.data.noticeType;
                        params.serviceid = "noticetype";
                        params.method = $scope.status.isEdit ? "updateNoticetype" : "saveNoticetype";
                        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getMessageUrl(), params, "POST").then(function(data) {
                            $modalInstance.close();
                            defer.resolve();
                            // 传播事件
                            $rootScope.$broadcast('mcLeftData', 'create')
                        });
                    });
                return defer.promise;
            }
        }
    ]);